import spacetime from 'spacetime';

import { SelectOption } from '../components/FormSelect';

export interface FormFields {
  name: string;
  occasion: SelectOption;
  relationship: SelectOption;
  date: Date;
  sendViaEmail: boolean;
  sendViaSms: boolean;
}
export const toSelectOption = (o: any) => ({
  value: o.uid,
  label: o.title,
  iconUrl: o?.thumb_image,
  hoverIconUrl: o?.hover_image,
});

const occasionType = (o: any) => ({
  uid: o.uid,
  title: o.title,
  notificationHeader: o.notification_header,
  thumbImage: o.thumb_image,
  hoverImage: o.hover_image,
  iconImage: o.icon_image,
  calendarDotColour: o.calendar_dot_colour,
  recurrenceType: o.recurrence_type,
  hidden: o.hidden,
  nextOccurrenceInCurrentLocale: o.next_occurence_in_current_locale,
});

export const toListOption = (o: any) => ({
  uid: o.uid,
  archivedAt: o.archived_at,
  customer: o.customer,
  nextOccurrenceDate: o.next_occurrence_date,
  heading: o.heading,
  recipientName: o.recipient_name,
  relationship: o.relationship,
  occasion: occasionType(o.occasion),
  occasionDate: o.occasion_date,
  sendViaEmail: o.send_via_email,
  sendViaSms: o.send_via_sms,
  orderNumber: o.order_number,
});

export const formDataToDto = (data: FormFields, orderNumber?: string) => ({
  recipient_name: data.name,
  relationship: data.relationship.value,
  occasion: data.occasion.value,
  occasion_date: spacetime(data.date).format('{year}-{iso-month}-{date-pad}'),
  send_via_email: data.sendViaEmail,
  send_via_sms: data.sendViaSms,
  order_number: orderNumber,
});

export enum ReminderActivityType {
  Save = 'save',
  New = 'new',
}

export enum ReminderVia {
  Both = 'both',
  Email = 'email',
  Sms = 'sms',
}
